<template>
  <div class="kr-layout-content">
    <div class="adaption-top">
      <!-- <i class="iconfont icon-fanhui1" @click="back"></i> -->
      <div class="logo">
        <img src="../../assets/img/logo.png" alt />
      </div>
      <div class="open" @click.stop="codeShow">下载APP</div>
      <div v-if="topShow" class="open-code" style="left:calc(100% - 75px);margin-left:0px">
        <img src="../../assets/img/code.png" alt />
      </div>
    </div>
    <!--左边-->
    <div class="content-left">
      <!--公司名称-->
      <div class="post-details">
        <div class="post-name">{{content.title}}</div>
        <ul class="sea-list">
          <div class="new-img">
            <img :src="content.userHeadPic" alt />
          </div>
          <p class="time">
            <span>{{content.userName}}</span>
            · {{content.createTime}}
          </p>
          <!-- <p class="intro">{{content.keyWorks}}</p> -->
        </ul>
        <!-- <p class="source">编者按：作者：张潇尹，36氪经授权转载。</p>
        <p class="summary">共享汽车的用户体验似乎正在直线下降。</p>-->
        <!--文章-->
        <div class="article">
          <!-- <p class="title">{{content.subTitle}}</p> -->
          <div class="content" v-html="content.content"></div>
        </div>
		 <div style="display: flex;align-items: center;justify-content: space-between;font-size: 12px;color: #999;margin-bottom:2px;">
		   <div>阅读:{{content.readNumVo}}</div>
		   <div>{{content.createTime}}</div>
	  </div>
        <!--特别声明-->
        <div class="notice">
          <p class="title">特别声明</p>
          <p>{{content.des}}</p>
        </div>
        <!--图片-->
        <!-- <div class="publicity-img">
          <img :src="content.pic" />
        </div>-->
        <!--赞-->
        <div class="zan" @click="getZan" style="margin-top:30px;">
          <i :class="['iconfont', 'icon-zan', isZanEd == 1 ?'active':'']"></i>
          <p v-text="content.zanNum"></p>
        </div>
        <p class="encourage">好文章需要你的鼓励</p>
        <!--评论-->
        <div class="user-data">
          <div class="top">
            <div class="head-img">
              <img :src="content.userHeadPic" alt />
            </div>
            <div class="author">
              {{content.userName}}
              <!-- <span class="card">新锐作者</span> -->
            </div>
            <ul class="share">
              <li>
                <i class="iconfont icon-pinglun"></i>
                {{content.commentNum}}
              </li>
              <li @click="getCollect">
                <i :class="['iconfont','icon-shoucang1',isCangEd == 1 ? 'active':'']"></i>
                {{content.shoucangNum}}
              </li>
              <!-- <li>|</li>
              <li>
                <i class="iconfont icon-weixin"></i>
              </li>
              <li>
                <i class="iconfont icon-weibo"></i>
              </li>-->
            </ul>
          </div>
          <div class="top-img">
            <img src="../../assets/img/msg.png" alt />参与评论
          </div>
          <div class="eval">
            <textarea placeholder="说一下你的意见吧" v-model="opinion" v-on:input="getLength"></textarea>
            <div class="submit">
              <div v-if="replayeval" class="new-user">
                回复：
                <span v-text="nickname"></span>
                <img src="../../assets/img/close1.png" alt @click="cancelReply" />
              </div>
              <button v-if="subeval" @click="subOpinion">提交评论</button>
              <button v-if="replayeval" @click="revert">回复</button>
              <span class="state">
                <i v-text="desLen"></i> / 1000
              </span>
            </div>
          </div>
        </div>
        <p class="remind">请回复有价值的信息，无意义的评论将很快被删除，账号将被禁止发言。</p>
        <div class="eval-list">
          <div class="top-img">
            <img src="../../assets/img/msg.png" alt />评论区
          </div>
          <ul class="author-list">
            <li v-for="item in evala" :key="item.id">
              <div class="author-img">
                <img :src="item.userHeadPic" />
              </div>
              <div class="cont">
                <p class="nick">
                  {{item.userName}}
                  <span class="time">· {{item.createTime}}</span>
                  <span class="reply">
                    <i
                      :class="['iconfont', 'icon-zan', item.isZanEd ==1  ? 'active': '']"
                      @click="getZanEval($event,item.id)"
                    ></i>
                    <span @click="reply(item.id,item.userName)">回复</span>
                  </span>
                </p>
                <p class="email">{{item.contentTarget}}</p>
                <!-- 回复评论 -->
                <Common v-if="item.children.length != 0" :prop="item.children" @reply="reply"></Common>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--右边-->
    <div class="content-right">
      <div class="author-details">
        <div class="user-data" >
          <div class="user">
            <div class="user-img">
              <img :src="content.userHeadPic" alt />
            </div>
            <div class="cont">
              <p class="nick oneline">{{content.userName}}</p>
              <!-- <span class="rank">新锐作者</span> -->
              <span class="rank care" @click="Care()" v-text="isFocusEd==0?'关注':'已关注'"></span>
              <span class="pub-num">发表{{content.newsCount}}篇文章</span>
            </div>
          </div>

          <div class="post-details">
            <ul class="sea-list conceal">
              <p class="time">{{perdata.keyWorks?perdata.keyWorks:''}}</p>
              <p class="intro">发表{{content.newsCount}}篇文章</p>
            </ul>
            <div class="article">
              <p class="title">发表{{content.newsCount}}篇文章</p>

              <div class="essay">
                <div
                  class="essay-list"
                  v-for="(item,index) in essay"
                  :key="index"
                  @click="getData(item.id)"
                >
                  <p class="content">{{item.title?item.title:''}}</p>
                  <p class="time">{{item.createTime}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="content.newsCount>0" class="look-more" @click="details(content.newsCount,content.userId)">阅读更多内容，狠戳这里</div>
        <div v-if="nextessay.title " class="user-data next-author">
          <div class="next">下一篇</div>
          <div class="next-art" @click="getData(nextessay.id)">
            <p class="next-title" style="cursor:pointer">{{nextessay.title}}</p>
            <p class="next-cont">{{nextessay.subTitle}}</p>
            <p class="time">{{nextessay.createTime}}</p>
          </div>
        </div>
        <!-- <div class="adaption-bottom">
          <div class="open" @click="codeShow">打开“ 建筑档案APP ”, 阅读全文</div>
          <div v-if="adaption" class="open-code">
            <img src="../../assets/img/code.png" alt />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { join } from "path";
import $ from "jquery";
import Common from "../../components/common";
import { log } from "util";
import { stringify } from "querystring";
import wx from "weixin-js-sdk";
export default {
  components: {
    Common
  },
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      content: {},
      evala: [],
      isZanEd: 0,
      isCangEd: 0,
      isFocusEd: 0,
      zanEval: false,
      desLen: 0,
      opinion: "",
      pid: "",
      subeval: true,
      replayeval: false,
      nickname: "",
      userId: "",
      perdata: {},
      essay: [],
      nextessay: {},
      count: 0,
      adaption: false,
      topShow: false,
      shareTitle: "",
      userDes: "",
      describe: "",
      firstImg: ""
    };
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    adaptionShow() {
      this.adaption = !this.adaption;
    },
    codeShow() {
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if(isiOS) {
			window.location.href = 'https://apps.apple.com/cn/app/%E5%BB%BA%E7%AD%91%E6%A1%A3%E6%A1%88/id1477141350';
		}else{
			window.location.href = 'https://appgallery.huawei.com/#/app/C101058233?locale=zh_CN&source=appshare&subsource=C101058233&shareTo=weixin&shareFrom=appmarket';
		}
      // this.topShow = !this.topShow;
    },
    checkWx() {
      var that = this;
      this.$http
        .post("/api/wx/xiaochengxu/JSSDKConfig", {
          url: location.href.split("#")[0]
        })
        .then(res => {
          console.log(res, "小程序等");
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
          });

          wx.ready(function() {
            // console.log(window.location.href)
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: that.shareTitle, // 分享标题
              desc: that.describe, // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.firstImg, // 分享图标
              success: function() {
                // 设置成功
              }
            });
            wx.updateTimelineShareData({
              title: that.shareTitle, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.firstImg, // 分享图标
              success: function() {
                // 设置成功
              }
            });
          });
          wx.error(function(res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取数据
    getData(tid) {
      this.$http
        .get("/api/core/002-1--newsDetail", {
          params: {
            id: tid,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          console.log(res, "详情");
          if (res.status == 200 && res.data.code == 0) {
			  if(res.data.rows.length<=0){
				  this.$message('已删除');
			  }
            this.content = res.data.rows[0];
            this.shareTitle = res.data.rows[0].title;
            this.userDes = res.data.rows[0].content;
            this.count = res.data.rows[0].newsCount;
            this.isZanEd = res.data.rows[0].isZanEd;
            this.isCangEd = res.data.rows[0].isCangEd;
            this.isFocusEd = res.data.rows[0].isFocusEd;
            this.check(this.content.userId);
            this.describe =
              $(this.userDes)
                .text()
                .substr(0, 20) + "......";
            if (res.data.rows[0].pic!='') {
              // this.firstImg = $(this.userDes)
              //   .find("img")
              //   .attr("src");
			  this.firstImg = res.data.rows[0].pic
            }
			
			var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
			  this.checkWx();
			}
			
			this.$nextTick(function(){
				$('.kr-layout-content').find('img').each(function(){
					console.log($(this).attr('src'))
					var src = $(this).attr('src')
					if(src.indexOf('http://img01.store.sogou.com/net/a/04/link?appid=100520029&url=')!=-1){
						$(this).attr('src',src.split('http://img01.store.sogou.com/net/a/04/link?appid=100520029&url=')[1])
					}
				})
			})
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询作者个人数据
    check(userId) {
      this.$http
        .get("/api/core/002--newsList", {
          params: {
            type: 1,
            userId: userId,
            limit: 10
          }
        })
        .then(res => {
          // console.log(res, "个人数据");
          if (res.status == 200 && res.data.code == 0) {
            this.perdata = res.data.rows[0];
            this.nextessay = res.data.rows[1];
            this.essay = res.data.rows;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    details(num, userId) {
      //进入个人主页
      if (num > 0) {
        this.$router.push({
          path: "/personal",
          query: { userId: userId, count: this.count }
        });
      }
    },
    Care() {
      // console.log(this.content.userId + '--' + this.content.userName)
      //关注
      this.$http
        .get("/api/core/009-userFocusPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: this.type,
            friendId: this.content.userId,
            friendName: this.content.userName
          }
        })
        .then(res => {
          // console.log(res, "关注");
          if (res.data.code == 0) {
            if (res.data.msg == "取关成功") {
              this.isFocusEd = 0;
            } else {
              this.isFocusEd = 1;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    subOpinion() {
      //提交评论
      var _str =
        "?token=" +
        this.$store.state.userInfo.token +
        "&thirdId=" +
        this.id +
        "&type=" +
        this.type +
        "&contentSource=" +
        this.opinion;
      this.$http
        .get("/api/core/006-userCommentPc" + _str)
        .then(res => {
          // console.log(res, "提交评论");
          if (res.data.code === 0) {
            // alert("提交成功");
			this.$message('评论成功');
            this.getEval();
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 点击回复传参
    reply(pid, nickname) {
      this.subeval = false;
      this.replayeval = true;
      this.pid = pid;
      this.nickname = nickname;
    },
    // 取消回复
    cancelReply() {
      this.subeval = true;
      this.replayeval = false;
      this.pid = "";
      this.nickname = "";
    },
    // 回复评论
    revert() {
      this.$http
        .get("/api/core/006-userCommentPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 1,
            thirdId: this.id,
            contentSource: this.opinion,
            pId: this.pid
          }
        })
        .then(res => {
          // console.log(res, "提交回复");
          if (res.data.code === 0) {
            // alert("提交成功");
			this.$message('回复评论成功');
            this.subeval = true;
            this.replayeval = false;
            this.getEval();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //点赞
    getZan() {
      this.$http
        .get("api/core/005-userZanPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: this.type,
            thirdId: this.id
          }
        })
        .then(res => {
          console.log(res, "点赞");
          if (res.data.msg == "取消点赞成功") {
            this.isZanEd = 0;
          } else {
            this.isZanEd = 1;
          }
          this.getData();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //评论点赞
    getZanEval(e, pid) {
      this.$http
        .get("api/core/005-userZanPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 5,
            thirdId: pid
          }
        })
        .then(res => {
          // console.log(res, "评论点赞");
          $(e.target).toggleClass("active");
        })
        .catch(err => {
          console.log(err);
        });
    },
    //收藏
    getCollect() {
      this.$http
        .get("/api/core/004-userShouCangPc", {
          params: {
            token: this.$store.state.userInfo.token,
            thirdId: this.id,
            type: this.type,
            thirdName: this.content.userName
          }
        })
        .then(res => {
          // console.log(res, "收藏");
          if (res.status == 200 && res.data.code == 0) {
            if (res.data.msg == "取消收藏成功") {
              this.isCangEd = 0;
              console.log(this.isCangEd);
            } else {
              this.isCangEd = 1;
              console.log(this.isCangEd);
            }
            this.getData();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //评论列表
    getEval() {
      this.$http
        .get("/api/core/008-commentList", {
          params: {
            token: this.$store.state.userInfo.token,
            thirdId: this.id,
            type: this.type
          }
        })
        .then(res => {
          // console.log(res, "评论列表");
          if (res.status == 200 && res.data.code == 0) {
            this.evala = res.data.rows;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取textarea 长度
    getLength() {
      this.desLen = this.opinion.length;
      if (this.desLen > 1000) {
        alert("字数过长");
        return false;
        this.desLen = this.desLen.substr(0, 30);
      }
    }
  },
  mounted() {
    this.getData(this.id);
    this.getEval();
    
  }
};
</script>
<style scoped>
	.content{
		text-align: left;
	}
	
.post-details .sea-list .new-img {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  margin-right: 10px;
  overflow: hidden;
  float: left;
}
.post-details .sea-list .time {
  width: calc(100% - 50px);
  float: left;
  line-height: 32px;
}
.post-details .user-data .top .share li {
  float: right;
}
.adaption-top,
.adaption-bottom {
  display: none;
}
.content-right {
  padding-top: 0px;
}
.user-data,
.look-more {
  width: 100%;
}
.user-data .user .cont .rank {
  float: left;
}
.sea-list::after {
  content: "";
  display: block;
  clear: both;
  width: 100px;
  height: 1px;
  background: #ededed;
}
.sea-list.conceal {
  display: none;
}
.post-details .article {
  margin-top: 20px;
}
.card {
  float: none;
  margin-left: 10px;
  font-weight: normal;
}
.top-img {
  margin-top: 25px;
}
.post-details .author-list li .cont .nick {
  margin-bottom: 15px;
}
.post-details .author-list li .comment .replay-list {
  margin-top: 10px;
}
.post-details .author-list li .comment .email {
  font-size: 12px;
}
.author-details .pub-num {
  float: left;
  font-size: 12px;
  margin: 5px 0px 0px 10px;
  display: none;
}
.author-details .next-art p.next-title:hover {
  color: #2e8043;
}
@media (min-width: 1280px) and (max-width: 1366px) {
}
@media (min-width: 1100px) and (max-width: 1279px) {
}
@media (min-width: 800px) and (max-width: 1099px) {
  .post-details .post-name {
    font-size: 23px;
  }
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    padding: 30px 0px 60px 20px;
  }
}
@media (min-width: 720px) and (max-width: 799px) {
  .post-details .post-name {
    font-size: 22px;
  }
  .content-left {
    padding-bottom: 0px;
  }
}
@media (min-width: 640px) and (max-width: 719px) {
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    padding: 30px 0px 60px 20px;
  }
  .post-details .post-name {
    font-size: 20px;
  }
}
@media (max-width: 639px) and (min-width: 501px) {
  .content-left {
    padding-bottom: 0px;
  }
  .post-details .post-name {
    font-size: 18px;
  }
  .post-details .user-data .top {
    padding-left: 15px;
  }
  .post-details .user-data .top .author {
    width: calc(100% - 220px);
  }
  .post-details .user-data .top .share {
    width: 180px;
  }
  .post-details .user-data .top .share li {
    margin: 0px 5px;
  }
  .post-details .user-data .top .share li i.icon-pinglun {
    margin-right: 4px;
  }
  .post-details .notice {
    min-height: 76px;
    padding: 13px 26px;
  }
  .post-details .notice .title {
    font-size: 16px;
  }
  .post-details .publicity-img {
    height: 115px;
  }
  .post-details .zan {
    width: 60px;
    height: 60px;
    padding-top: 12px;
  }
}
@media (min-width: 320px) and (max-width: 500px) {
  .post-details .post-name {
    font-size: 18px;
  }
  .post-details .article {
    margin-top: 24px;
  }
  .post-details .article .title {
    margin-bottom: 20px;
  }
  .post-details .notice {
    min-height: 70px;
    padding: 12px 15px;
  }
  .post-details .notice p {
    font-size: 12px;
    line-height: 20px;
  }
  .post-details .notice .title {
    font-size: 14px;
  }
  .post-details .publicity-img {
    height: 100px;
  }
  .post-details .zan {
    width: 50px;
    height: 50px;
    padding-top: 6px;
  }
  .post-details .user-data .top {
    padding: 12px 0px 12px 15px;
  }
  .post-details .user-data .top .author {
    display: none;
  }
  .post-details .user-data .top .share {
    width: 220px;
  }
  .post-details .user-data .top .share li {
    margin: 0px 10px;
  }
  .post-details .author-list li .cont .email,
  .post-details .encourage {
    font-size: 12px;
  }
  /* .author-details .user-data{margin-top:0px;} */
  .content-left {
    padding: 10px 0px 0px 0px;
  }
  /* .author-details .user-data .user .user-img{width:70px;} */
  .user-data .user {
    height: 70px;
  }
  .user-data .user .cont .nick {
    margin-top: 10px;
    font-size: 16px;
  }
  .post-details .sea-list .time {
    margin-bottom: 8px;
  }
  .author-details .sea-list .intro {
    margin-bottom: 13px;
  }
  .author-details .post-details .article {
    margin-top: 15px;
  }
  .author-details .post-details .article .title {
    margin-bottom: 15px;
  }
  .author-details .post-details .article .essay-list {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ddd;
  }
  .author-details .post-details .article .essay-list:last-child{
	  margin-bottom: 0;
  }
  .author-details .post-details .article .content {
    font-size: 12px!important;
  }
  .author-details .post-details .article .content p{
    font-size: 12px!important;
  }
  .author-details .next {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
  }
  .author-details .next-art p.next-title {
    font-size: 14px;
  }
  .author-details .next-art p.next-cont {
    font-size: 12px;
  }
  .author-details .next-art p {
    margin: 5px 0px;
  }

  /* 隐藏 */
  .top-header .adaption-top {
    width: 100%;
    height: 100%;
    padding: 0px 12px;
    position: relative;
  }
  .post-details .post-name {
    font-size: 16px;
  }
  .post-details .publicity-img {
    display: none;
  }
  .post-details .article {
    margin-top: 15px;
  }
  .post-details .article .content {
    margin-bottom: 10px;
    font-size: 12px!important;
  }
  .post-details .article .content p{font-size: 12px!important;}
  .post-details .zan,
  .post-details .encourage,
  .post-details .remind {
    display: none;
  }
  .post-details .user-data,
  .eval-list {
    display: none;
  }
  .author-details .user-data {
    margin-top: 0px;
    border: none;
    padding: 0px;
  }
  .user-data .user .user-img {
    width: 40px;
    height: 40px;
  }
  .author-details .user-data .user .cont {
    width: calc(100% - 60px);
  }
  .user-data .user .cont .nick {
    margin-top: 0px;
    font-size: 14px;
  }
  .author-details .pub-num {
    display: block;
  }
  .user-data .user {
    margin-top: 15px;
  }
  .author-details .post-details .article {
    margin-top: 0px;
  }
  .post-details .article .title {
    margin-top: 0px;
    font-weight: normal;
  }
  .next-author {
    display: none;
  }
  .kr-layout .kr-layout-main .main-right .kr-layout-content {
    min-height: auto;
    margin-bottom: 0px;
  }
  .author-details .post-details .article .title {
    display: none;
  }
  .author-details .post-details .article .time {
    font-size: 12px;
  }

  /* 头部隐藏 */
  .adaption-top {
    display: block;
    width: calc(100% - 24px);
    height: 50px;
    line-height: 50px;
    position: fixed;
    top: 0px;
    z-index: 989;
    background: #fff;
  }
  .adaption-top::after {
    content: "";
    width: 110%;
    height: 1px;
    background: #bbb;
    position: absolute;
    left: -12px;
    right: 0px;
    bottom: 0px;
  }

  .adaption-top i {
    float: left;
    margin-top: 14px;
    font-size: 22px;
    position: absolute;
    left: -5px;
  }
  .adaption-top p {
    text-align: center;
    width: calc(100% - 60px);
    font-size: 18px;
    position: absolute;
    left: 30px;
  }

  /* 打开详情*/
  .adaption-top .logo {
    width: auto;
    height: 26px;
    float: left;
  }
  .adaption-top .logo img {
    height: 100%;
    width: auto;
  }
  .adaption-top .open {
    width: 80px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    color: #0a8228;
    margin-top: 12px;
    float: right;
    border: 1px solid #0a8228;
  }
  .adaption-top .open-code {
    width: 70px;
    height: 70px;
    padding: 8px 3px 3px;
    position: absolute;
    right: 6px;
    top: 40px;
    background: url("../../assets/img/code-bg.png") no-repeat;
    background-size: 100% 100%;
  }

  .look-more {
    display: none;
  }
  .adaption-bottom {
    display: block;
    width: 100%;
    height: auto;
    position: relative;
  }
  .adaption-bottom .open {
    width: 260px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    margin: 10px auto;
    color: #0a8228;
    border: 1px solid #0a8228;
  }
  .open-code {
    width: 70px;
    height: 70px;
    padding: 8px 3px 3px;
    position: absolute;
    left: 50%;
    margin-left: -35px;
    top: 25px;
    background: url("../../assets/img/code-bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .content-right {
    padding-bottom: 0px;
  }
}
.post-details .article img {
  height: auto !important;
  margin-bottom: 0px;
}
</style>